import type React from "@platform/react";
import type { PropDefaults, PropElement, PropTypes } from "@platform/react-storybook/Component";
import type { UuidText, UuidPresetText } from "@front/components/Element/Text/types";
import type { UuidBitmapAsset } from "@common/content/asset/bitmap";
import type { PropBox } from "@front/components/Element/Box/types";
import type { FilterUnion } from "@platform/types/union";

import Namespace from "./_index.scss";

export const { NAME_SECTION_CARD, TYPE_SECTION_CARD } = Namespace;

export const PRESET_CARD = [
    "vertical-simple",
    "square-data",
    "horizontal-info",
    "challenge",
] as const;

export type UuidTextTag = FilterUnion<UuidText, `categories-${string}`>;

export type CardDescripcion = {
    name: string;
    timer: string;
};

type PropWithCrackId = {
    /** Id of the Crack */
    "crack-id"?: string;
    /** A `uuid` if provided, the corrresponding description will be rendered */
    desc?: never;
};

type PropWithDescription = {
    desc?: UuidText;
    "crack-id"?: never;
};

export type PresetCard = typeof PRESET_CARD[number];

export type ClickEventButton = null | React.MouseEventHandler<HTMLButtonElement>;

export type PropSectionCard = PropElement &
    Omit<PropElement, "children"> &
    (PropWithCrackId | PropWithDescription) & {
        /** Pick one of the available Card presets to customize the look and feel of the box */
        preset: PresetCard;
        /** A  `uuid` if provided, the corrresponding TAG will be rendered */
        tag?: UuidTextTag;
        /** Uuid of Card background image */
        bitmap: UuidBitmapAsset;
        /** A  `uuid` if provided, the corrresponding TITLE will be rendered */
        title?: UuidText;
        /** Pick one of the available Text presets to customize the look  the Title */
        "title-preset"?: UuidPresetText;
        /** Pick one of the available Text presets to customize the look the descripcion */
        "desc-preset"?: UuidPresetText;
        /** Informacion the Video or section */
        "data-video"?: CardDescripcion;
        /** If the Card is Pattern  */
        hasPattern?: boolean;
        /** Determines whether to add a shadow to the bottom of the card */
        hasShadow?: boolean;
        /** If the box is disabled  */
        locked?: PropBox["locked"];
        /** URI where you browse */
        href: string;
        /** If it has a title  */
        hasFade?: boolean;
    };

export const DEF_SECTION_CARD: PropDefaults<
    Omit<
        PropSectionCard,
        | "tag"
        | "title"
        | "title-preset"
        | "desc"
        | "desc-preset"
        | "data-video"
        | "hasPattern"
        | "hasShadow"
        | "locked"
        | "crack-id"
        | "hasFade"
    >
> = {};

export type DefSectionCard = typeof DEF_SECTION_CARD;

export type PropTypesSectionCard = PropTypes<PropSectionCard, DefSectionCard>;
